import _ from 'lodash';
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("subscriptionCheckoutStep1Address", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/checkout/subscriptionCheckoutStep1AddressView.html",
            controller: ["subscriptionCheckoutService", "subscriptionResource", "globalizationService", "messageService", "$state", SubscriptionCheckoutStep1AddressCtrl],
            controllerAs: "vm"
        };
        function SubscriptionCheckoutStep1AddressCtrl(subscriptionCheckoutService, subscriptionResource, globalizationService, messageService, $state) {
            var vm = this;
            vm.showErrors = false;
            vm.loading = true;
            vm.formData = subscriptionCheckoutService.model;
            vm.countrySettings = {};
            if (!subscriptionCheckoutService.wizard.isReady) {
                $state.go("main.settings.subscription");
                return;
            }
            subscriptionResource.getCheckout(function (result) {
                vm.countrySettings.enabledCountries = result.enabledCountries;
                vm.formData.billingAddress = result.billingAddress;
                initStep1();
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
                initStep1();
                vm.loading = false;
            });
            function initStep1() {
                subscriptionCheckoutService.setStep(1);
                vm.loadStateProvince = function (countryId) {
                    var countryObj = _.find(vm.countrySettings.enabledCountries, { id: countryId });
                    globalizationService.load(countryObj.threeLetterISOCode, function (result) {
                        vm.stateProvinceLabel = result.stateProvinceLabel;
                        vm.postalZipLabel = result.postalZipLabel;
                        vm.postalZipRegex = new RegExp(result.postalZipRegex);
                        vm.postalZipPattern = result.postalZipPattern;
                    });
                    vm.countrySettings.stateProvinces = countryObj.provinces;
                };
                if (vm.formData.billingAddress) {
                    vm.formData.billingAddress.saveToAccount = false;
                    if (vm.formData.billingAddress.countryId)
                        vm.loadStateProvince(vm.formData.billingAddress.countryId);
                }
                else {
                    vm.formData.billingAddress = {
                        saveToAccount: true
                    };
                }
                vm.next = function () {
                    if (vm.step1form.$valid) {
                        subscriptionCheckoutService.wizard.isStep1Valid = true;
                        $state.go("main.settings.subscriptionCheckout.step2", {}, { location: "replace" });
                    }
                    else {
                        vm.showErrors = true;
                    }
                };
            }
        }
    });
}());
